import raccoonSignup from "@/assets/brand/raccoon-signup.webp";
import raccoonBuild from "@/assets/brand/raccoon-build.webp";
import raccoonBoba from "@/assets/brand/raccoon-boba.webp";
import type { FaqItem } from "@/components/landing/FaqList";

// The copy every participant-facing page shares: the landing page and each of
// the thirty-odd city pages. It lives here rather than in either of them so
// that answering "do I need to know how to code?" once answers it everywhere -
// an organizer overrides the parts they wrote themselves and inherits the rest.

// The Figma's three illustrated cards, in its order and with its titles. The
// middle one sits higher than its neighbours on desktop.
export const WHAT_YOU_DO = [
  {
    title: "sign up",
    art: raccoonSignup,
    body: "Find your city and put your name down. It's free, and you don't need an idea yet.",
  },
  {
    title: "build projects",
    art: raccoonBuild,
    body: "Bring a laptop. You've got three to five hours to make a website out of plain HTML and CSS. No experience needed, and a page about your cat counts.",
  },
  {
    title: "get boba!",
    art: raccoonBoba,
    body: "Order whatever you want, it's on us. Then show the room what you made and go home having built something.",
  },
];

// The same three cards for a city that collects websites before the day rather
// than during it. Not a tweak of the wording above: the order of events is
// genuinely different, so an attendee who reads "you've got three to five hours
// on the day" turns up having built nothing, and the city gets nothing for them.
export const WHAT_YOU_DO_BEFORE = [
  {
    title: "sign up",
    art: raccoonSignup,
    body: "Find your city and put your name down. It's free, and you don't need an idea yet.",
  },
  {
    title: "build a website",
    art: raccoonBuild,
    body: "Before the day, at home, in your own time. Plain HTML and CSS, no experience needed, and a page about your cat counts. Hand it in before the event starts.",
  },
  {
    title: "get boba!",
    art: raccoonBoba,
    body: "Turn up, order whatever you want, it's on us. Show the room what you built and meet everyone else who made something.",
  },
];

export const DEFAULT_FAQ: FaqItem[] = [
  {
    q: "Do I need to know how to code?",
    a: "Nope. Loads of people write their first line of HTML that afternoon. Whoever is sitting next to you will help you get something on the screen.",
  },
  {
    q: "What should I bring?",
    a: "A laptop and a charger. That's the whole list. No laptop? Say so when you sign up and your organizer will sort you out.",
  },
  {
    q: "How long does it run?",
    a: "Three to five hours, usually an afternoon. It's not overnight, and you can leave whenever you need to.",
  },
  {
    q: "Does it cost anything?",
    a: "No. It's free to come and the boba is on us.",
  },
  {
    q: "How old do I have to be?",
    a: "It's for teenagers, so roughly 13 to 18. Older than that and you can still come help out on the day, just talk to whoever runs your city.",
  },
  {
    q: "Do I need a team or an idea?",
    a: "Neither. There are no teams, everyone makes their own site. Turn up with nothing and figure out what to build once you get there.",
  },
  {
    q: "What do people actually make?",
    a: "Websites. HTML and CSS, small enough to finish in one sitting: a page about your cat, a fan site for a band, a dumb quiz. Finished and silly beats ambitious and broken.",
  },
];
